<template>
  <div class="bodyDiv">
    <div>
      <div class="header">
        <div class="headCenter Center1200">
          <div class="headCenter Center1200">
            <div class="logo">
              <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png">
            </div>
            <div>北京商务服务发展地图</div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="margin-left: 20px;height: 59px">
              <el-menu-item index="1">国际化发展</el-menu-item>
              <el-menu-item index="2">北京市布局</el-menu-item>
            </el-menu>
          </div>
          <el-dropdown style="cursor:pointer;">
            <span class="el-dropdown-link" style="display: flex;align-items: center;">
              <el-avatar icon="el-icon-user-solid"></el-avatar>
              <p style="color: white;margin-left: 10px;">{{userName.account}}</p>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="handleClick('signOut')">安全退出</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="handleClick('Back')">用户中心</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <nav class="headCenter Center1200">
        <img src="@/assets/ding.png" style="margin-right: 20px;">
        <Crumbs :Nav="JSON.stringify(Nav)"></Crumbs>
      </nav>
    </div>
    <div class="Center1200" style="background: white;flex:1;">
      <div class="conHeader">
        <el-form :model="form" ref="form" label-width="100px"  label-position="right">
          <el-form-item label="企业名称：" class="width45" prop="name">
            <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
          </el-form-item>

          <el-form-item label="行业类别：" class="width45" prop="industryType">
            <el-select v-model="form.industryType" clearable placeholder="请选择">
              <el-option v-for="(item,Key) in industryList" :key="Key" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属区：" class="width45" prop="district">
            <el-select v-model="form.district" clearable filterable placeholder="请选择">
              <el-option v-for="(item,Key) in districtsList" :key="Key" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="width6">
            <el-button @click="renderList()" class="el_button"  type="primary" size="small" plain><i class="el-icon-search"></i> 查询</el-button>
            <el-button @click="Add()" class="el_button"  type="success" size="small"><i class="el-icon-plus"></i> 新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="企业名称" width="300"></el-table-column>
        <el-table-column prop="industryTypeName" label="行业类别" width="180"></el-table-column>
        <el-table-column prop="districtName" label="注册地址"></el-table-column>
        <el-table-column width="180" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="Edit(scope.row)" class="el_button"  type="primary" size="mini" plain><i class="el-icon-edit"></i>修改</el-button>
            <el-button @click="Remove(scope.row)" class="el_button"  type="danger" size="mini" plain><i class="el-icon-delete"></i>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align:right;margin:20px 0px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import {
  ListApi,
  DelApi,
  districtsApi,
  industriesApi
  } from "@/api/ent2/EntList";
import Crumbs from '@/components/crumbs.vue';

export default {
  name: "EntAdd",
  components:{
    Crumbs
  },
  data() {
    return {
      userName: '',
      activeIndex: '2',
      currentPage: 1,
      Nav:[{
        name:'北京市发展地图'
      },{//面包屑
        name:'企业信息列表'
      }],
      tableData: [],
      form: {//点击查询所需要的参数
        name: '',
        industryType: '',
        countryCode: '',
        coverage: ''
      },
      size: 10,
      total: 0,
      industryList: [],//所有行业
      districtsList: []//所有国家
    }
  },
  created(){
    this.userName = JSON.parse(sessionStorage.getItem('user'))
    districtsApi().then((res) => {//获取北京地区
      this.districtsList = res.data.data
    });
    industriesApi().then((res) => {//获取全部行业
      that.industryList = res.data.data;
    });
    let that = this;
    this.renderList();
  },
  methods: {
    renderList(){//获取Table数据
      let that = this;
      let data = this.form;
      for(let val in data){
        if(data[val] == ''){
          delete data[val];
        }
      }
      ListApi({params:data}).then((res) => {
        var data = res.data.data;
        this.tableData = data.records;
        that.total = Number(data.total);
      });
    },
    // 当前页多少条
    handleSizeChange(val) {
      this.form.size = val;
      this.renderList();
    },
    // 当前多少页
    handleCurrentChange(val) {
      this.form.current = val;
      this.renderList();
    },
    Remove(row){
      DelApi({params:{entId:row.id}}).then((res) => {
        if(res.status){
            this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.renderList();
        }
      });
    },
    Edit(row){
      this.$router.push({path: '/bjent/add', query: {id: row.id}});
    },
    Add(){
      this.$router.push({path: '/bjent/add',query:{}});
    },
    handleSelect(val) {
      if(val == 1) {
        this.$router.push({path: '/ent/list',query:{}});
      } else{
        this.$router.push({path: '/bjent/list',query:{}});
      }
    },
    handleClick(type){
    if(type == 'signOut'){
      sessionStorage.clear();
      window.location.href = '/web/userCenter/'
    }else{
      window.location.href = '/web/userCenter#/Usercenter'
    }
    },
  }
}
</script>

<style scoped>
  .el-menu-demo, .el-menu--horizontal, .el-menu {
    background: hsla(0,0%,100%,0)!important;
  }
  .el-menu--horizontal>.el-menu-item{
  padding: 0px 44px;
  font-size: 20px;
    height: 59px;
    line-height: 59px;
  }
  .el-menu-demo li {
    background: #BA0132 !important;
    color: white !important;
  }
  .el-menu-demo li:hover {
    background: #BA0132 !important;
  }
  .el-menu.el-menu--horizontal{
    border: none !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 1px solid white !important;
    background: #990012 !important;
  }
  .bodyDiv{
    width: 100%;
    height: 100%;
    background: rgb(250,250,250);
    display: flex;
    flex-direction: column;

  }
  .header{
    width: 100%;
    height: 60px;
    background: rgb(186,0,49);
  }
  .headCenter{
    height: 100%;
    display: flex;
    align-items: center;
    color: white;
    font-size: 24px;
    font-family: '方正正中黑简体';
  }
  .logo{
    width: 40px;
    height: 40px;
    display: flex;
    font-size: 14px;
    margin-right: 35px;
    border-radius: 4px;
    background: white;
    align-items: center;
    color: rgb(186,0,49);
    justify-content: center;
  }
  .logo img{
    width: 54px;
  }
  nav{
    height: 44px !important;
    border-bottom:  1px solid #DCDFE6;
    margin-bottom: 10px !important;
  }
  .Center1200{
    width: 1200px;
    margin: 0 auto;
  }
  .context{
    padding: 30px 0px;
  }
  form{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 20px;
  }
  .width45{
    width: 25.6%;
    margin: 0px;
  }

  form .width90{
    width: 90%;
  }
  form .el-form-item__label{
    width: 100% !important;
  }
  .el-select{
    width: 100%;
  }
  .el-table{
    width: 1170px !important;
    margin: 20px 15px;
  }
</style>
